import { IllegalStateError } from "shared-ts-utils-core";

const safeAccess = <T, K extends PropertyKey>(
  obj: T | undefined,
  key: K
): any => {
  try {
    // @ts-expect-error - Intentionally using optional chaining with potentially undefined objects
    return obj?.[key];
  } catch (e) {
    return undefined;
  }
};

const envFromVite = (name: string): string | undefined => {
  const viteEnvKey = `VITE_${name}`;
  let value: string | undefined;
  try {
    // First check for window.__VITE_IMPORT_META_ENV__
    // (sometimes used in certain Vite configurations)
    const viteMetaEnv = safeAccess(window, "__VITE_IMPORT_META_ENV__");
    value = safeAccess(viteMetaEnv, viteEnvKey);
    if (value) return value;

    const { env } = import.meta as any;
    value = safeAccess(env, viteEnvKey);
    if (value) return value;
  } catch (e) {
    // Ignore errors from accessing potentially unavailable objects
  }
  return value;
};

export const env = (name: string): string => {
  const value = envFromVite(name);
  if (value !== undefined) return value;

  throw new IllegalStateError(`Environment variable ${name} is not defined`);
};
